import React from 'react';
import { IconButton, SxProps, Theme } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';

export interface BackButtonProps {
  onClick: () => void;
  'aria-label'?: string;
  sx?: SxProps<Theme>;
  disabled?: boolean;
}

const BackButton: React.FC<BackButtonProps> = ({
  onClick,
  'aria-label': ariaLabel = 'Back',
  sx,
  disabled = false,
}) => {

  return (
    <IconButton
      onClick={onClick}
      aria-label={ariaLabel}
      sx={sx}
      disabled={disabled}
    >
      <ArrowBack sx={{ color: (theme) => theme.palette.brand?.primary  }} />
    </IconButton>
  );
};

export default BackButton;